export default __webpack_public_path__ + "static/media/cr.e6331153.svg";